import React from 'react';

import {ROUTE_NAMES} from "../../../core/consts";
import {observer} from "mobx-react";
import styles from "../../match-widget/modules/match-events-module/styles/match-event.module.scss";
import {MATCH_EVENTS} from "../../match-widget/modules/match-events-module/match-events-widget.consts";
import {Popup} from "../../../core/components/misc/dialog/popup";
import {CompetitorPlayersStatsModule} from "../../../modules/competitor-players-stats-module/components/competitor-players-stats-module";
import classNames from "classnames";

export const BoxScoresWidgetPlayerCard = observer(({controller}) => {
  const {state, device} = controller;
  const {selectedAthleteId, isPlayerCardPopupVisible} = state;
  const {isSmallView} = device;

  const popupPlayerProp = {
    className: classNames(styles.popup, {[styles.small_view]: isSmallView}),
    onClose: () => onClosePlayerPopup()
  }

  const onClosePlayerPopup = () => controller.action(MATCH_EVENTS.ACTION_TYPES.onPlayerCardPopupClick, {isVisible: false});

  const playerCardModuleProps = {
    gameId: controller.props.gameId,
    source: ROUTE_NAMES.game,
    fetchFullLineup: true,
    selectedAthleteId,
    onClose: () => onClosePlayerPopup(),
  }

  return (
    isPlayerCardPopupVisible ? <Popup {...popupPlayerProp}>
      <CompetitorPlayersStatsModule {...playerCardModuleProps}/>
    </Popup> : null
  )
});
